import { render, staticRenderFns } from "./SummaryTab.vue?vue&type=template&id=2bbe2300&scoped=true&"
import script from "./SummaryTab.vue?vue&type=script&lang=js&"
export * from "./SummaryTab.vue?vue&type=script&lang=js&"
import style0 from "./SummaryTab.vue?vue&type=style&index=0&id=2bbe2300&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbe2300",
  null
  
)

export default component.exports